<template></template>

<script>
import db from "../../js/db";
import mixins from "../../js/mixins";
import Config from '../../../config-app/config';

export default {
  name: "swal-save-rose",
  mixins: [mixins],
  components: {},
  mounted() {
    db.on("showSaveRose", this.saveRose);
    db.on("handleApiCallSuccess", this.handleApiCallSuccess);
  },
  destroyed() {
    db.off("showSaveRose", this.saveRose);
    db.off("handleApiCallSuccess", this.handleApiCallSuccess);
  },
  computed: {},
  methods: {
    handleApiCallSuccess(apiName) {
      if (apiName == "exportRose") {
        this.astaLogRoseExported();
      }
    },
    saveRose() {
      Swal.fire({
        title: "Salva rose",
        html:
          '<div style="text-align: left;color: #607D8B;">' +
          "Le assegnazioni fatte in Asta Live saranno <strong>salvate permanentemente</strong> e quindi visibili anche nelle altre sezioni di app/sito" +
          "<br><br>" +
          '<div style="border-radius: 3px; font-size: smaller; color: white; background: #7997a5; padding: 10px">' +
          '<i class="fa fa-info-circle"></i> Perchè salvare?<br>' +
          "Perchè il tool Asta Live <strong>non si sincronizza automaticamente</strong> con le altre sezioni di sito/app.<br>" +
          "Per rendere permanenti le modifiche effettuate con Asta Live devi <strong>salvare le rose</strong>." +
          "</div>" +
          "</div>",
        showCancelButton: true,
        confirmButtonText: "Salva",
        cancelButtonText: "Annulla",
        preConfirm: () => {
          return this.preConfirmApiCall();
        },
      }).then((result) => {
        if (result.isConfirmed == true) {
          this.handleApiCall("/firebase_export_rose.php", "exportRose");
        }
      });
    },
  },
};
</script>
<style></style>
